import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { Button, Modal } from 'react-bootstrap';
import { START_DATE, END_DATE } from 'react-dates/constants';

import { TODAY } from '../../../utils/dates';

import './styles/DateRangePickerModal.css';
import { isEqual } from 'lodash';

export const DATETIMEFORMAT = 'YYYY-MM-DD';

class DateRangePickerModal extends React.Component {
  constructor(props) {
    super(props);

    const endDate = moment(TODAY).startOf('day');
    const startDate = moment(TODAY)
      .subtract(7, 'days')
      .startOf('day');

    this.state = { focusedInput: null, endDate, startDate };

    this.isOutsideRange = this.isOutsideRange.bind(this);
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onInternalDatesUpdated = this.onInternalDatesUpdated.bind(this);
    this.isDayPermitted = this.isDayPermitted.bind(this);
    this.isDayBlocked = this.isDayBlocked.bind(this);
  }

  componentDidUpdate({ dates: prevDates }) {
    const { dates } = this.props;
    if (dates && !isEqual(dates, prevDates)) {
      const datesMapping = dates.reduce((memo, date) => {
        memo[date] = moment(date);
        return memo;
      }, {});
      this.setState({
        datesMapping
      });
    }
  }

  onInternalDatesUpdated() {
    const { onDatesChange } = this.props;
    const { startDate, endDate } = this.state;

    if (startDate && endDate) {
      onDatesChange({ startDate, endDate });
    }
  }

  onDatesChange(dates) {
    const endDate = dates.endDate ? dates.endDate.startOf('day') : null;
    const startDate = dates.startDate ? dates.startDate.startOf('day') : null;

    this.setState({ endDate, startDate });
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  isDayPermitted(date) {
    if (!this.props.dates.length) {
      return undefined;
    }
    let isPermitted = false;
    if (this.state.datesMapping) {
      const dateKey = date.format(DATETIMEFORMAT);
      isPermitted = !!this.state.datesMapping[dateKey];
    }
    return isPermitted;
  }

  isDayBlocked(date) {
    if (!this.props.dates.length) {
      return false;
    }
    let isDayBlocked = false;
    if (!this.isOutsideRange(date)) {
      isDayBlocked = !this.isDayPermitted(date);
    }
    return isDayBlocked;
  }

  isOutsideRange(date) {
    const { isFuture } = this.props.props;
    const newMin = this.props.minDate;
    let newMax = this.props.maxDate;

    if (!isFuture) {
      newMax = moment(TODAY).startOf('day');
    }

    return date.isBefore(newMin) || date.isAfter(newMax);
  }

  renderRangePicker() {
    const { focusedInput, startDate, endDate } = this.state;

    return (
      <DateRangePicker
        endDate={endDate}
        endDateId={END_DATE}
        focusedInput={focusedInput}
        isOutsideRange={this.isOutsideRange}
        onDatesChange={this.onDatesChange}
        onFocusChange={this.onFocusChange}
        isDayBlocked={this.isDayBlocked}
        isDayHighlighted={this.isDayPermitted}
        startDate={startDate}
        startDateId={START_DATE}
        hideKeyboardShortcutsPanel
      />
    );
  }

  render() {
    return (
      <Modal
        className="tvt-filters__input-date-modal"
        show={this.props.show}
        onHide={this.props.onClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderRangePicker()}</Modal.Body>
        <Modal.Footer>
          <Button
            bsSize="sm"
            className="tvt-filters__btn"
            onClick={this.onInternalDatesUpdated}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DateRangePickerModal.propTypes = {
  props: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDatesChange: PropTypes.func.isRequired,
  minDate: PropTypes.shape({}).isRequired,
  maxDate: PropTypes.shape({}).isRequired,
  show: PropTypes.bool,
  dates: PropTypes.shape([])
};

DateRangePickerModal.defaultProps = {
  show: false
};

export default DateRangePickerModal;
